import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// CI-5: single client entry point for the backend Pacing/Capacity engine
// (backend/services/pacing.py). The backend is the source of truth for daily
// readiness — capacity is a 0-100 score blending the daily check-in, today's
// pain (as a cap), and HealthKit/Health-Connect signals when present. Both the
// Strength readiness badge and the Dashboard PacingBanner read from here so they
// can never disagree.
//
// Vendor-neutral by design: the backend consumes a generic `body_metrics` shape,
// so Apple Health, Google Health Connect, Garmin, etc. all feed the same score —
// nothing here is Apple-specific.
export const usePacing = (refreshKey = 0) => {
  const { user } = useAuth();
  const [pacing, setPacing] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!user) return undefined;
    let cancelled = false;
    setLoading(true);
    (async () => {
      try {
        // TZ offset so the engine floors "today"/"this week" against the user's
        // local clock, not UTC. getTimezoneOffset() → +480 for PST, -120 CEST.
        const tzOffset = new Date().getTimezoneOffset();
        const res = await axios.get(`${API}/pacing`, { params: { tz_offset_minutes: tzOffset } });
        if (!cancelled) {
          setPacing(res.data);
          setError(false);
        }
      } catch {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [user, refreshKey]);

  return {
    pacing,
    capacity: pacing?.capacity || null,
    loading,
    error,
  };
};

export default usePacing;
